// extracted by mini-css-extract-plugin
module.exports = {"muscleGroupFilter":"Exercises_muscleGroupFilter__1QCIC"};